import { NavLink, Outlet } from 'react-router';
import { AlertTriangle, Clock, LayoutList, ListTree, Sparkles, Ticket } from 'lucide-react';
import { useSettings } from '../api/hooks';
import { formatDate, formatOffset } from '../lib/format';

const NAV = [
  { to: '/', label: 'Commandes', icon: Ticket, end: true },
  { to: '/horloge', label: 'Horloge', icon: Clock, end: false },
  { to: '/erreurs', label: 'Erreurs forcées', icon: AlertTriangle, end: false },
  { to: '/journal', label: 'Journal', icon: ListTree, end: false },
  { to: '/referentiel', label: 'Référentiel', icon: LayoutList, end: false },
  { to: '/scenarios', label: 'Scénarios', icon: Sparkles, end: false },
];

export default function Layout() {
  const { data: settings } = useSettings({ refetchInterval: 5000 });
  const offset = settings?.clockOffsetSeconds ?? 0;

  return (
    <div className="flex min-h-full bg-bg text-white">
      <aside className="sticky top-0 flex h-screen w-64 shrink-0 flex-col self-start border-r border-line bg-bg">
        <div className="px-4 py-5">
          <p className="text-2xl/7 font-bold tracking-[0.48px] text-white">BO preprod · Fan Wallet</p>
          <p className="mt-1 text-xs uppercase tracking-[0.12em] text-outline">simulateur Trium</p>
        </div>
        <nav className="flex flex-1 flex-col gap-0.5 overflow-y-auto px-2">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 border-l-[3px] px-3 py-2.5 text-sm font-semibold transition ${
                  isActive
                    ? 'border-primary bg-white/5 text-white'
                    : 'border-transparent text-outline hover:bg-hover hover:text-white'
                }`
              }
            >
              <Icon size={16} aria-hidden />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-line px-4 py-4 text-xs">
          <p className="uppercase tracking-[0.12em] text-outline">Heure serveur</p>
          <p className="mt-1 font-mono text-sm text-white">{formatDate(settings?.serverNow)}</p>
          <p className={`mt-1 font-semibold ${offset !== 0 ? 'text-ganymede' : 'text-outline'}`}>
            {formatOffset(offset)}
          </p>
        </div>
      </aside>
      <main className="min-w-0 flex-1 overflow-x-hidden p-6">
        <Outlet />
      </main>
    </div>
  );
}
